import PropTypes from 'prop-types';
import './VibeButtonGroup.scss';

function VibeButtonGroup({
  className = '',
  style = {},
  children,
}) {
  return (
    <div
      className={`VibeButtonGroup ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}

VibeButtonGroup.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default VibeButtonGroup;
